<div
  class="select-field"
  [ngClass]="{
    'has-value': selectedOption && selectedOption?.key !== placeholder,
    condensed: condensed
  }"
>
  <div
    class="select-label-wrapper field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: formControl?.disabled
    }"
  >
    <label
      class="select-label"
      type="select"
      [attr.for]="fieldId"
      (click)="dropdown.open()"
    >
      {{ label }}
    </label>

    <app-icon
      *ngIf="icon"
      class="icon"
      [icon]="icon"
      (click)="onClickIcon.emit()"
    >
    </app-icon>
  </div>

  <app-dropdown
    #dropdown
    class="select-dropdown"
    [dropdownGroupedItems]="dropdownValues"
    [e2eId]="e2eId"
    [disabled]="isDisabled"
    [dropdownId]="fieldId"
    [horizontalAlignment]="horizontalAlignment"
    [verticalAlignment]="verticalAlignment"
    [dynamicVAlignment]="dynamicVAlignment"
    [triggerLabel]="selectedOption?.key || placeholder"
    [trackingObject]="trackingObject"
    [trackingAction]="trackingTapped"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
  >
    <ng-template
      let-closeCallback="closeCallback"
      let-selectOption="dropdownItem"
    >
      <button
        type="button"
        [disabled]="isDisabled || selectOption.disabled"
        tabindex="0"
        [attr.data-e2e-id]="selectOption.e2eId"
        [ngClass]="[
          SELECT_OPTION_CLASS,
          selectOption.key === selectedOption?.key ? 'selected' : ''
        ]"
        (click)="onSelect(selectOption); closeCallback()"
      >
        <div class="select-option-contents">
          {{ selectOption.key }}

          <app-checkmark
            class="checkmark"
            [hidden]="selectOption.key !== selectedOption?.key"
          >
          </app-checkmark>

          <app-icon
            *ngIf="selectOption.icon"
            class="select-option-icon"
            [icon]="selectOption.icon"
          >
          </app-icon>
        </div>
      </button>
    </ng-template>
  </app-dropdown>
</div>

<app-error-message [fieldControl]="fieldControl" [errorMessage]="errorMessage">
</app-error-message>

<p *ngIf="description" class="description">
  {{ description }}
</p>
